module.exports = __webpack_public_path__ + "footchatu1.png?b1eb069c504b49280d9010d91097c82f";